/* ==========================================================
   TARİH YARDIMCI FONKSİYONLARI
========================================================== */

// Başlangıç tarihini günün 00:00:00'una çeker
export const toStartOfDay = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);
  return d;
};

// Bitiş tarihini günün 23:59:59'una çeker
export const toEndOfDay = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  d.setHours(23, 59, 59, 999);
  return d;
};
